// Ported 1:1 from the Webflow page markup (scraped/). Class names and data-w-id
// attributes must stay intact: webflow.css and the IX2/Lottie runtime key off them.
export default function VenturesPage() {
  return (
    <>
      <section className="section">
        <div className="content">
          <div className="block-top">
            <h1 className="heading-top h1-as-h2">
              <strong>{"Our Ventures "}</strong>
            </h1>
            <p className="paragraph-top">Find below our ventures in #AI, #Communities &amp; Events, #Sales and #HR</p>
          </div>
          <div className="w-layout-grid grid-about">
            <div id="w-node-cf25a25b-0e66-dbff-6957-9aeabf006334-59985356" className="about height space-around">
              <img src="/assets/cdn/6565e4c502b773cabf34a82a_Skillie.png" loading="eager" sizes="110.57500457763672px" srcSet="/assets/cdn/6565e4c502b773cabf34a82a_Skillie-p-500.png 500w, /assets/cdn/6565e4c502b773cabf34a82a_Skillie.png 600w" alt="Skillie logo" className="icon-about logo" />
              <p className="paragraph-about">AI-powered Recruitment Platform and a Job-Board builder for coworking spaces and VCs</p>
              <p className="paragraph-top">
                <strong>#AI; #HR; #Communities</strong>
              </p>
              <a href="https://www.skillie.ai/" target="_blank" className="button w-button">Go to website</a>
            </div>
            <div id="w-node-c8c01932-6567-3a63-5ec5-b1791151d5c0-59985356" className="about height green space-around">
              <img src="/assets/cdn/6565e47f2e33cb6f1da83867_Immersica.svg" loading="eager" alt="Immersica logo" className="icon-about logo" />
              <p className="paragraph-about green">AI Training Agents to build up sales and communication skills</p>
              <p className="paragraph-top">
                <strong>#AI; #HR</strong>
              </p>
              <a href="https://www.immersica.io/" target="_blank" className="button w-button">Go to website</a>
            </div>
            <div id="w-node-c8c01932-6567-3a63-5ec5-b1791151d5ca-59985356" className="about height red space-around">
              <img src="/assets/cdn/6565e5123a8baeec8d987d92_VR%20Express%20Logo%20Dark.svg" loading="eager" alt="VR Express logo" className="icon-about logo" />
              <p className="paragraph-about red">3D Avatars &amp; VR to attract attention at fairs and expos</p>
              <p className="paragraph-top">
                <strong>#Events; #HR</strong>
              </p>
              <a href="https://www.vrexpress.io/en" target="_blank" className="button w-button">Go to website</a>
            </div>
            <div id="w-node-c8c01932-6567-3a63-5ec5-b1791151d5b6-59985356" className="about height space-around">
              <img src="/assets/cdn/66bb40622ced157cddc2a03b_kognifyLogo.png" loading="eager" sizes="124.05000305175781px" srcSet="/assets/cdn/66bb40622ced157cddc2a03b_kognifyLogo-p-500.png 500w, /assets/cdn/66bb40622ced157cddc2a03b_kognifyLogo.png 800w" alt="Kognify logo" className="icon-about logo" />
              <p className="paragraph-about">An AI Assistant builder platform based on the RAG technology</p>
              <p className="paragraph-top">
                <strong>#AI; #Sales</strong>
              </p>
              <a href="https://www.kognify.ai/" target="_blank" className="button w-button">Go to website</a>
            </div>
            <div id="w-node-_2c855ecd-9af2-9dde-352b-93b18f82bf16-59985356" className="about height green space-around">
              <img src="/assets/cdn/relinkd-logo.svg" loading="eager" alt="Relinkd logo" className="icon-about logo" />
              <p className="paragraph-about green">Personal Network Activation App</p>
              <p className="paragraph-top">
                <strong>#AI; #Communities</strong>
              </p>
              <a href="https://relinkd.net/" target="_blank" className="button w-button">Go to website</a>
            </div>
            <div id="w-node-_7d5ce3e4-6ded-a0e9-68bb-87aeb62a6b9a-59985356" className="about height red space-around">
              <img src="/assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo.png" loading="eager" sizes="(max-width: 479px) 53vw, 141.9250030517578px" srcSet="/assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo-p-500.png 500w, /assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo-p-800.png 800w, /assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo.png 1000w" alt="VibeJobs logo" className="icon-about logo" />
              <p className="paragraph-about red">A Viber Job Board for Blue-collar workers</p>
              <p className="paragraph-top">
                <strong>#HR</strong>
              </p>
              <a href="https://vibejobs.net/" target="_blank" className="button w-button">Go to website</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
